// Only the CRA development server exposes these fixed proxy routes.
const xmlRequestUrl = url => {
    if (process.env.NODE_ENV !== 'development') return url
    const endpoints = [
        [process.env.REACT_APP_GUIAECTS_CURSOS, '/__ipb_xml/courses'],
        [process.env.REACT_APP_GUIAECTS_CURSO_DETALHE, '/__ipb_xml/course'],
        [process.env.REACT_APP_GUIAECTS_EXTRA_CURRICULAR, '/__ipb_xml/extra'],
        [process.env.REACT_APP_WEBDOCS, '/__ipb_xml/documents']
    ]
    for (const [endpoint, route] of endpoints) {
        if (endpoint && (url === endpoint || url.startsWith(`${endpoint}?`))) {
            return route + url.slice(endpoint.length)
        }
    }
    return url
}

export default xmlRequestUrl
